module.exports = __webpack_public_path__ + "static/media/delete.f74d4fc3.svg";